import Cookies from 'js-cookie';

// export const hasPermission = (permission = []) => {
//      const permissionArray = JSON.parse(Cookies.get('Permission')) || [];
//     let show = false
//     permission.map((item) => {
//         if (permissionArray.includes(item)) {
//             show = true
//         }
//
//     })
//     return show
// };
export const hasPermission = (permission = []) => {
    const PermissionCookie =Cookies.get('Permission')
    const permissionArray = PermissionCookie ? JSON.parse(PermissionCookie) :   [];
    let show = false;

    permission.forEach((item) => {
        if (permissionArray.includes(item)) {
            show = true;
        }
    });

    return show;
};